import { Navigate, Route, Routes as BaseRoutes } from "react-router";

import { DashboardLayout } from "./layouts/dashboard";
import { Account } from "./routes/account";
import { AuthCallback } from "./routes/auth-callback";
import { CreateSKU } from "./routes/create-sku";
import { GasCalculator } from "./routes/gas-calculator";
import { Images } from "./routes/images";
import { NoOrganization } from "./routes/no-org";
import { Organization } from "./routes/organization";
import { Organizations } from "./routes/organizations";
import { Owners } from "./routes/owners";
import { Sku } from "./routes/sku";
import { Skus } from "./routes/skus";
import { Splash } from "./routes/splash";
import { Tag } from "./routes/tag";
import { Tags } from "./routes/tags";
import { Tracks } from "./routes/tracks";
import { Verifications } from "./routes/verifications";
import { Videos } from "./routes/videos";
import { Advanced as WebExperienceAdvanced } from "./routes/web-experience/advanced";
import { Content as WebExperienceContent } from "./routes/web-experience/content";
import { Integrations as WebExperienceIntegrations } from "./routes/web-experience/integrations";
import { Layout as WebExperienceLayout } from "./routes/web-experience/layout";

const Routes = () => (
  <BaseRoutes>
    <Route path="/" element={<Splash />} />
    <Route path="/auth/callback" element={<AuthCallback />} />
    <Route path="/no-organization" element={<NoOrganization />} />

    <Route path="skus/:skuId/web-experience" element={<WebExperienceLayout />}>
      <Route index element={<Navigate to="content" replace />} />
      <Route index path="content" element={<WebExperienceContent />} />
      <Route path="integrations" element={<WebExperienceIntegrations />} />
      <Route path="advanced" element={<WebExperienceAdvanced />} />
    </Route>

    <Route element={<DashboardLayout />}>
      <Route path="skus">
        <Route index element={<Skus />} />
        <Route path="create" element={<CreateSKU />} />
        <Route path=":skuId" element={<Sku />} />
        <Route path=":skuId/product" element={<Sku />} />
        <Route path=":skuId/overview" element={<Sku />} />
        <Route path=":skuId/analytics" element={<Sku />} />
        <Route path=":skuId/webpage" element={<Sku />} />
        <Route path=":skuId/blockchain" element={<Sku />} />
      </Route>

      <Route path="images" element={<Images />} />
      <Route path="videos" element={<Videos />} />
      <Route path="tracks" element={<Tracks />} />

      <Route path="owners" element={<Owners />} />

      <Route path="tags">
        <Route index element={<Tags />} />
        <Route path=":tagUid" element={<Tag />} />
      </Route>

      <Route path="verifications" element={<Verifications />} />
      <Route path="organization" element={<Organization />} />
      <Route path="organizations" element={<Organizations />} />
      <Route path="gas-calculator" element={<GasCalculator />} />
      <Route path="account" element={<Account />} />
    </Route>
  </BaseRoutes>
);

export default Routes;
